import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ForbiddenPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
    >
      <Typography variant="h2" color="error" gutterBottom>
        403
      </Typography>
      <Typography variant="h5" gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        You don’t have permission to access this page.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate("/dashboard")}>
        Go to Home
      </Button>
    </Box>
  );
};

export default ForbiddenPage;
